(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-intake-form"] && !Shopify.designMode) return;
  try {
    
  function bindContentIntake(form) {
    if (form.dataset.bound === "true") return;
    form.dataset.bound = "true";
    var api = (form.getAttribute("data-api-url") || "").replace(/\/$/, "");
    var maxBytes = Number(form.getAttribute("data-max-bytes") || 2147483648);
    var maxFiles = Number(form.getAttribute("data-max-files") || 20);
    var statusEl = form.querySelector("[data-intake-status]");
    var submitBtn = form.querySelector("[data-submit]");
    var fileInput = form.querySelector("[data-files-input]");
    var drop = form.querySelector("[data-drop]");
    var dropLabel = form.querySelector("[data-drop-label]");
    var fileList = form.querySelector("[data-file-list]");
    var uploadPanel = form.querySelector("[data-upload-panel]");
    var uploadTrack = form.querySelector("[data-upload-track]");
    var uploadBar = form.querySelector("[data-upload-bar]");
    var addFilesLabel = (dropLabel && dropLabel.textContent) || "Upload photos / videos";
    var chosen = [];

    function field(name) {
      return form.elements.namedItem(name);
    }

    function setBar(percent, show) {
      if (uploadBar) uploadBar.style.width = Math.max(0, Math.min(100, percent)) + "%";
      if (uploadTrack) uploadTrack.hidden = !show;
      if (uploadPanel && show) uploadPanel.hidden = false;
    }

    function setStatus(message, kind) {
      if (!statusEl) return;
      statusEl.hidden = !message;
      statusEl.textContent = message || "";
      statusEl.className = "sylke-forms__status";
      if (kind === "error" || kind === "success") {
        statusEl.className += " alert alert--" + kind;
        setBar(0, false);
      }
      if (uploadPanel) uploadPanel.hidden = !message && (!uploadTrack || uploadTrack.hidden);
    }

    function syncFilled(control) {
      var wrap = control.closest(".sylke-forms__field");
      var label = wrap && wrap.querySelector(".sylke-forms__label");
      if (!label) return;
      label.classList.toggle("is-filled", Boolean(String(control.value || "").trim()));
    }

    function syncAllFilled() {
      form.querySelectorAll(".sylke-forms__input").forEach(syncFilled);
    }

    function jsonHeaders(token) {
      var headers = { "Content-Type": "application/json" };
      if (token) headers["X-Upload-Token"] = token;
      return headers;
    }

    function parseJsonText(text) {
      if (!text) return {};
      try {
        return JSON.parse(text);
      } catch (error) {
        return {};
      }
    }

    async function readJson(response) {
      var payload = parseJsonText(await response.text());
      if (!response.ok) {
        throw new Error(payload.error || "Upload failed. Try again.");
      }
      return payload;
    }

    async function postJson(path, token, body) {
      return readJson(
        await fetch(api + path, {
          method: "POST",
          headers: jsonHeaders(token),
          body: JSON.stringify(body)
        })
      );
    }

    function sameFile(a, b) {
      return a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;
    }

    function allowedFile(file) {
      return /\.(jpe?g|png|webp|gif|heic|heif|mp4|mov|m4v|webm)$/i.test(file.name);
    }

    function addFiles(fileListLike) {
      var incoming = Array.prototype.slice.call(fileListLike || []);
      for (var i = 0; i < incoming.length; i += 1) {
        var file = incoming[i];
        if (chosen.some(function (existing) { return sameFile(existing, file); })) continue;
        if (!allowedFile(file) || file.size < 1) {
          setStatus(file.name + " is not a photo or video we can accept.", "error");
          continue;
        }
        if (chosen.length >= maxFiles) {
          setStatus("You can upload up to " + maxFiles + " files.", "error");
          break;
        }
        if (file.size > maxBytes) {
          setStatus(file.name + " is over the size limit.", "error");
          continue;
        }
        chosen.push(file);
      }
      renderFiles();
    }

    function renderFiles() {
      if (!fileList || !dropLabel) return;
      fileList.innerHTML = "";
      fileList.hidden = chosen.length === 0;
      dropLabel.textContent = addFilesLabel;
      if (drop) drop.classList.toggle("is-filled", chosen.length > 0);
      chosen.forEach(function (file, index) {
        var item = document.createElement("li");
        item.className = "sylke-forms__file-item";
        item.innerHTML =
          '<div class="sylke-forms__file-meta">' +
            '<span class="sylke-forms__file-name"></span>' +
            '<div class="sylke-forms__file-track" data-progress hidden><span class="sylke-forms__file-fill"></span></div>' +
          "</div>" +
          '<button type="button" class="sylke-forms__remove" data-remove>Remove</button>';
        item.querySelector(".sylke-forms__file-name").textContent = file.name;
        item.querySelector("[data-remove]").addEventListener("click", function () {
          chosen.splice(index, 1);
          renderFiles();
        });
        fileList.appendChild(item);
      });
    }

    function friendlyError(error) {
      var msg = (error && error.message) || "";
      if (msg === "Load failed" || msg === "Failed to fetch" || msg.indexOf("NetworkError") !== -1) {
        return "The video upload dropped. Stay on this page and press Submit again.";
      }
      return msg || "Upload failed. Try again.";
    }

    function sleep(ms) {
      return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    async function putChunk(url, uploaded, end, file) {
      var attempts = 4;
      var lastError = new Error("Upload dropped.");
      for (var attempt = 1; attempt <= attempts; attempt += 1) {
        try {
          var res = await fetch(url, {
            method: "PUT",
            headers: {
              "Content-Length": String(end - uploaded),
              "Content-Range": "bytes " + uploaded + "-" + (end - 1) + "/" + file.size,
              "Content-Type": "application/octet-stream"
            },
            body: file.slice(uploaded, end)
          });
          if (res.ok) return res;
          var data = parseJsonText(await res.text());
          lastError = new Error((data.error && data.error.message) || "SharePoint upload failed.");
        } catch (error) {
          lastError = error;
        }
        if (attempt < attempts) await sleep(700 * attempt);
      }
      throw lastError;
    }

    async function uploadSharePoint(token, init, file, onProgress) {
      var chunk = init.chunkBytes || 10485760;
      var uploaded = 0;
      var item = null;
      while (uploaded < file.size) {
        var end = Math.min(uploaded + chunk, file.size);
        var res = await putChunk(init.uploadUrl, uploaded, end, file);
        var data = parseJsonText(await res.text());
        uploaded = end;
        onProgress(Math.round((uploaded / file.size) * 100));
        if (res.status === 200 || res.status === 201) item = data;
      }
      if (!item || !item.id || !item.webUrl) {
        throw new Error("SharePoint did not confirm the file.");
      }
      return postJson("/v1/files/complete", token, {
        backend: "sharepoint",
        slot: init.slot,
        driveId: item.parentReference && item.parentReference.driveId,
        itemId: item.id,
        webUrl: item.webUrl,
        filename: file.name,
        size: file.size
      });
    }

    async function uploadR2(token, init, file, onProgress) {
      var chunk = init.chunkBytes || 8388608;
      var parts = [];
      var uploaded = 0;
      var partNumber = 1;
      while (uploaded < file.size) {
        var end = Math.min(uploaded + chunk, file.size);
        var res = await fetch(
          api + "/v1/files/part?key=" + encodeURIComponent(init.key) + "&partNumber=" + partNumber,
          {
            method: "PUT",
            headers: { "X-Upload-Token": token },
            body: file.slice(uploaded, end)
          }
        );
        var data = await readJson(res);
        parts.push({ partNumber: data.partNumber, etag: data.etag });
        uploaded = end;
        onProgress(Math.round((uploaded / file.size) * 100));
        partNumber += 1;
      }
      return postJson("/v1/files/complete", token, {
        backend: "r2",
        slot: init.slot,
        key: init.key,
        uploadId: init.uploadId,
        parts: parts
      });
    }

    async function uploadChosenFile(token, file, index, row, onOverall) {
      var track = row && row.querySelector("[data-progress]");
      var fill = row && row.querySelector(".sylke-forms__file-fill");
      if (track) track.hidden = false;
      var init = await postJson("/v1/files/init", token, {
        slot: index + 1,
        filename: file.name,
        contentType: file.type,
        size: file.size,
        website: field("website").value
      });
      if (init.ignored) return;
      function onProgress(percent) {
        if (fill) fill.style.width = percent + "%";
        if (onOverall) onOverall(file.size * (percent / 100));
      }
      try {
        if (init.backend === "sharepoint") {
          await uploadSharePoint(token, init, file, onProgress);
        } else {
          await uploadR2(token, init, file, onProgress);
        }
      } catch (error) {
        if (init.backend !== "sharepoint") throw error;
        var fallback = await postJson("/v1/files/init", token, {
          slot: index + 1,
          filename: file.name,
          contentType: file.type,
          size: file.size,
          forceR2: true,
          website: field("website").value
        });
        if (fallback.ignored) return;
        await uploadR2(token, fallback, file, onProgress);
      }
      if (onOverall) onOverall(file.size);
    }

    form.querySelectorAll(".sylke-forms__input").forEach(function (control) {
      control.addEventListener("input", function () { syncFilled(control); });
      control.addEventListener("change", function () { syncFilled(control); });
      syncFilled(control);
    });

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        addFiles(fileInput.files);
        fileInput.value = "";
      });
    }

    if (drop) {
      drop.addEventListener("dragover", function (event) {
        event.preventDefault();
      });
      drop.addEventListener("drop", function (event) {
        event.preventDefault();
        if (event.dataTransfer) addFiles(event.dataTransfer.files);
      });
    }

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      if (!api) {
        setStatus("Upload API URL is missing in the theme editor.", "error");
        return;
      }
      if (!chosen.length) {
        setStatus("Add at least one photo or video.", "error");
        return;
      }
      var required = ["firstName", "lastName", "email", "specialty", "procedureType"];
      for (var r = 0; r < required.length; r += 1) {
        if (!String(field(required[r]).value || "").trim()) {
          setStatus("Please complete the required fields.", "error");
          return;
        }
      }
      if (submitBtn) submitBtn.disabled = true;
      var totalBytes = chosen.reduce(function (sum, file) { return sum + file.size; }, 0) || 1;
      var finishedBytes = 0;
      setBar(0, true);
      setStatus("Uploading files… 0%", "info");
      if (submitBtn && submitBtn.scrollIntoView) {
        submitBtn.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      try {
        var session = await readJson(await fetch(api + "/v1/session", { method: "POST" }));
        var items = fileList ? fileList.querySelectorAll(".sylke-forms__file-item") : [];
        for (var i = 0; i < chosen.length; i += 1) {
          var startBytes = finishedBytes;
          await uploadChosenFile(session.token, chosen[i], i, items[i], function (currentFileBytes) {
            var done = startBytes + currentFileBytes;
            var percent = Math.min(100, Math.round((done / totalBytes) * 100));
            setBar(percent, true);
            setStatus("Uploading files… " + percent + "%", "info");
          });
          finishedBytes += chosen[i].size;
        }
        setBar(100, true);
        setStatus("Finishing submission…", "info");
        await postJson("/v1/submit", session.token, {
          firstName: field("firstName").value,
          lastName: field("lastName").value,
          email: field("email").value,
          repEmail: field("repEmail").value,
          facility: field("facility").value,
          cityRegion: field("cityRegion").value,
          specialty: field("specialty").value,
          procedureType: field("procedureType").value,
          notes: field("notes").value,
          patientRelease: Boolean(field("patientRelease").checked),
          website: field("website").value
        });
        chosen = [];
        renderFiles();
        form.reset();
        syncAllFilled();
        setStatus(form.getAttribute("data-success") || "Thanks — marketing has your files.", "success");
      } catch (error) {
        setStatus(friendlyError(error), "error");
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  document.querySelectorAll("[data-content-intake-form]").forEach(bindContentIntake);

  } catch(e) { console.error(e); }
})();
})();
